import { Component } from '@angular/core';

@Component({
  selector: 'bn-auth-email-confirmed',
  templateUrl: './email-confirmed.page.html',
  styleUrls: ['./email-confirmed.page.scss'],
  host: { class: 'bn-auth__page-container' },
  standalone: false,
})
export class EmailConfirmedPage {}
